module.exports = __webpack_public_path__ + "img/back02.31587f5a.png";